import {
  clearSessionOnExit,
  handleBeforeUnload,
  handleUnload,
  handleVisibilityChange,
} from "../../Login/functions/handlePage";

export const directReload = (direct: boolean = true) => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
  window.removeEventListener("beforeunload", clearSessionOnExit);
  window.removeEventListener("unload", handleUnload);
  window.removeEventListener("unload", clearSessionOnExit);
  window.removeEventListener("pagehide", handleUnload);
  window.removeEventListener("pagehide", clearSessionOnExit);
  document.removeEventListener("visibilitychange", handleVisibilityChange);
  if (direct) window.location.reload();
};
